<div *ngIf="showLoader" class="loader">
  <div class="loader-spinner">
    <div class="loader-shapes"></div>
  </div>
  <div *ngIf="loadingStep" class="loader-step">{{ loadingStep | translate: loadingStepParams }}</div>
</div>
